export const TicketStatus = [
  {name: 'PENDING'},
  {name: 'ANSWERED'},
  {name: 'CLOSED_BY_USER'},
  {name: 'CLOSED_BY_ADMIN'},
  {name: 'CLOSED_BY_SYSTEM'}];

